<template>
  <main class="main-section is-clipped">
    <slot />
  </main>
</template>

<script>
export default {
  name: 'MainSection'
}
</script>

<style lang="scss" scoped>
@import '../../sass/_variables.scss';

.main-section {
  margin-top: $navbar-height;
  margin-left: $sidebar-width;
  padding: $main-section-padding;
  padding-top: 15px;
  padding-bottom: $footer-height + $main-section-padding;
  transition: margin $animation-fast;
  position: relative;
  min-height: calc(100vh - 60px);
  min-width: 400px;
  background-color: var(--default);
}

.mini .main-section {
  margin-left: $sidebar-icon-width;
}

.sidebar-closed .main-section {
  margin-left: 0
}

@media only screen and (max-width: $break-small) {
  .main-section {
    padding: 3px;
    padding-bottom: $footer-height + 1px;
    min-width: 100vw;
  }

  .mini .main-section {
    margin-left: $sidebar-width;
  }

  .sidebar-closed .main-section {
    margin-left: 0
  }

}

</style>
